import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'firebaseProjectId',
  initialState: null as null | string,
  reducers: {
    setFirebaseProjectId(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFirebaseProjectId } = slice.actions;

export default slice.reducer;
